// Get environment variable with fallback value
export const getEnv = (key, defaultValue) => {
  if (import.meta.env.DEV) {
    return import.meta.env[key] || defaultValue;
  }
  return window.__ENV__?.[key] || defaultValue;
};

// Predefined environment variables with their defaults
export const env = {
  ZONE: getEnv('VITE_APP_ZONE', 'eu'),
  DEBUG: getEnv('VITE_APP_DEBUG', 'false') === 'true',
  LOGIN_MANAGER_HOST: getEnv('VITE_APP_LOGIN_MANAGER_HOST', ''),
  API_BASE_PATH: getEnv('VITE_APP_API_BASE_PATH', ''),
  GLOBAL_SSO_HOST: getEnv('VITE_APP_GLOBAL_SSO_HOST', ''),
  LOG_LEVEL: getEnv('VITE_APP_LOG_LEVEL', 'debug')
}; 